import React, { useState, useEffect } from 'react';
import { 
  Plus, Search, Filter, Download, Eye, Edit, Trash2, Send, CheckCircle, Clock, 
  AlertTriangle, XCircle, Calendar, Euro, FileText, User, Home, Anchor, Star,
  CreditCard, DollarSign, Percent, Mail, Phone, MapPin, X, Save, ChevronDown,
  BarChart3, TrendingUp, TrendingDown, ArrowUpRight, ArrowDownRight, Settings,
  Building, Users, Award, Gift, Car, Plane, Utensils, Copy, ExternalLink
} from 'lucide-react';

const InvoicesManagement = () => {
  const [activeView, setActiveView] = useState('list');
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showNewInvoiceModal, setShowNewInvoiceModal] = useState(false);
  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  
  // États pour le formulaire de nouvelle facture
  const [newInvoice, setNewInvoice] = useState({
    type: 'villa-rental',
    client: '',
    clientId: '',
    property: '',
    propertyId: '',
    booking: '',
    bookingId: '',
    items: [{ description: '', quantity: 1, unitPrice: 0, vatRate: 20 }],
    discountRate: 0,
    notes: '',
    dueDate: '',
    currency: 'EUR'
  });

  // Mock data pour les factures
  const [invoices, setInvoices] = useState([
    {
      id: 'INV-2024-001',
      number: 'FAC-2024-001',
      type: 'villa-rental',
      typeName: 'Location de Villa',
      status: 'paid',
      client: 'Famille Beaumont',
      clientId: 'CLI-001',
      clientEmail: 'contact@beaumont-family.com',
      property: 'Villa Azure Dreams',
      propertyId: 'VIL-001',
      booking: 'RES-2024-157',
      bookingId: 'BK-001',
      amount: 45000,
      currency: 'EUR',
      issueDate: '2024-09-01',
      dueDate: '2024-09-15',
      paidDate: '2024-09-12',
      vatAmount: 9000,
      discountAmount: 0,
      items: [
        { description: 'Location Villa Azure Dreams - 7 nuits', quantity: 7, unitPrice: 5000, vatRate: 20 },
        { description: 'Service de conciergerie premium', quantity: 1, unitPrice: 8000, vatRate: 20 }
      ]
    },
    {
      id: 'INV-2024-002',
      number: 'FAC-2024-002',
      type: 'concierge',
      typeName: 'Prestation Conciergerie',
      status: 'pending',
      client: 'Jean-Pierre Moreau',
      clientId: 'CLI-002',
      clientEmail: 'jp.moreau@gmail.com',
      property: 'Villa Sunset Paradise',
      propertyId: 'VIL-002',
      booking: 'RES-2024-158',
      bookingId: 'BK-002',
      amount: 12500,
      currency: 'EUR',
      issueDate: '2024-09-10',
      dueDate: '2024-09-25',
      paidDate: null,
      vatAmount: 2500,
      discountAmount: 500,
      items: [
        { description: 'Chef privé - 5 jours', quantity: 5, unitPrice: 1200, vatRate: 20 },
        { description: 'Service de spa à domicile', quantity: 2, unitPrice: 800, vatRate: 20 },
        { description: 'Transport privé (aéroport)', quantity: 2, unitPrice: 350, vatRate: 20 },
        { description: 'Activités nautiques privées', quantity: 1, unitPrice: 2500, vatRate: 20 }
      ]
    },
    {
      id: 'INV-2024-003',
      number: 'FAC-2024-003',
      type: 'yacht-rental',
      typeName: 'Location de Yacht',
      status: 'overdue',
      client: 'Sarah Johnson',
      clientId: 'CLI-003',
      clientEmail: 'sarah.johnson@luxury.com',
      property: 'Yacht Serenity',
      propertyId: 'YAC-001',
      booking: 'YAC-2024-125',
      bookingId: 'BK-003',
      amount: 85000,
      currency: 'EUR',
      issueDate: '2024-08-15',
      dueDate: '2024-08-30',
      paidDate: null,
      vatAmount: 17000,
      discountAmount: 2000,
      items: [
        { description: 'Charter Yacht Serenity - 5 jours', quantity: 5, unitPrice: 15000, vatRate: 20 },
        { description: 'Équipage professionnel', quantity: 5, unitPrice: 2000, vatRate: 20 },
        { description: 'Carburant et frais portuaires', quantity: 1, unitPrice: 8000, vatRate: 20 }
      ]
    },
    {
      id: 'INV-2024-004',
      number: 'FAC-2024-004',
      type: 'deposit',
      typeName: 'Acompte',
      status: 'paid',
      client: 'Famille Rodriguez',
      clientId: 'CLI-004',
      clientEmail: 'familia.rodriguez@spain.es',
      property: 'Villa Mediterranean',
      propertyId: 'VIL-003',
      booking: 'RES-2024-189',
      bookingId: 'BK-004',
      amount: 18000,
      currency: 'EUR',
      issueDate: '2024-09-05',
      dueDate: '2024-09-20',
      paidDate: '2024-09-08',
      vatAmount: 3600,
      discountAmount: 0,
      items: [
        { description: 'Acompte 30% - Villa Mediterranean', quantity: 1, unitPrice: 18000, vatRate: 20 }
      ]
    },
    {
      id: 'INV-2024-005',
      number: 'FAC-2024-005',
      type: 'apa',
      typeName: 'APA (Advance Provisioning Allowance)',
      status: 'draft',
      client: 'Marcus Thompson',
      clientId: 'CLI-005',
      clientEmail: 'marcus.thompson@corp.uk',
      property: 'Yacht Royal Crown',
      propertyId: 'YAC-002',
      booking: 'YAC-2024-134',
      bookingId: 'BK-005',
      amount: 25000,
      currency: 'EUR',
      issueDate: '2024-09-12',
      dueDate: '2024-09-27',
      paidDate: null,
      vatAmount: 5000,
      discountAmount: 0,
      items: [
        { description: 'APA - Provisions et frais de charter', quantity: 1, unitPrice: 25000, vatRate: 20 }
      ]
    }
  ]);

  // Types de factures
  const invoiceTypes = [
    { value: 'villa-rental', label: 'Location de Villa', icon: Building, color: 'blue' },
    { value: 'yacht-rental', label: 'Location de Yacht', icon: Anchor, color: 'navy' },
    { value: 'concierge', label: 'Prestation Conciergerie', icon: Star, color: 'purple' },
    { value: 'deposit', label: 'Acompte', icon: CreditCard, color: 'green' },
    { value: 'apa', label: 'APA', icon: DollarSign, color: 'orange' },
    { value: 'miscellaneous', label: 'Facture Diverses', icon: FileText, color: 'gray' }
  ];

  // Statuts de factures
  const invoiceStatuses = [
    { value: 'draft', label: 'Brouillon', color: 'gray', icon: FileText },
    { value: 'sent', label: 'Envoyée', color: 'blue', icon: Send },
    { value: 'pending', label: 'En attente', color: 'yellow', icon: Clock },
    { value: 'paid', label: 'Payée', color: 'green', icon: CheckCircle },
    { value: 'overdue', label: 'En retard', color: 'red', icon: AlertTriangle },
    { value: 'cancelled', label: 'Annulée', color: 'gray', icon: XCircle }
  ];

  // Mock data pour les clients
  const clients = [
    { id: 'CLI-001', name: 'Famille Beaumont', email: 'contact@beaumont-family.com' },
    { id: 'CLI-002', name: 'Jean-Pierre Moreau', email: 'jp.moreau@gmail.com' },
    { id: 'CLI-003', name: 'Sarah Johnson', email: 'sarah.johnson@luxury.com' },
    { id: 'CLI-004', name: 'Famille Rodriguez', email: 'familia.rodriguez@spain.es' },
    { id: 'CLI-005', name: 'Marcus Thompson', email: 'marcus.thompson@corp.uk' }
  ];

  // Mock data pour les propriétés
  const properties = [
    { id: 'VIL-001', name: 'Villa Azure Dreams', type: 'villa' },
    { id: 'VIL-002', name: 'Villa Sunset Paradise', type: 'villa' },
    { id: 'VIL-003', name: 'Villa Mediterranean', type: 'villa' },
    { id: 'YAC-001', name: 'Yacht Serenity', type: 'yacht' },
    { id: 'YAC-002', name: 'Yacht Royal Crown', type: 'yacht' }
  ];

  // Calculs de statistiques
  const stats = {
    totalAmount: invoices.reduce((sum, inv) => sum + inv.amount, 0),
    paidAmount: invoices.filter(inv => inv.status === 'paid').reduce((sum, inv) => sum + inv.amount, 0),
    pendingAmount: invoices.filter(inv => inv.status === 'pending').reduce((sum, inv) => sum + inv.amount, 0),
    overdueAmount: invoices.filter(inv => inv.status === 'overdue').reduce((sum, inv) => sum + inv.amount, 0),
    totalInvoices: invoices.length,
    paidInvoices: invoices.filter(inv => inv.status === 'paid').length,
    pendingInvoices: invoices.filter(inv => inv.status === 'pending').length,
    overdueInvoices: invoices.filter(inv => inv.status === 'overdue').length
  };

  // Fonctions utilitaires
  const getStatusColor = (status) => {
    const statusConfig = invoiceStatuses.find(s => s.value === status);
    return statusConfig ? statusConfig.color : 'gray';
  };

  const getStatusIcon = (status) => {
    const statusConfig = invoiceStatuses.find(s => s.value === status);
    return statusConfig ? statusConfig.icon : FileText;
  };

  const getTypeColor = (type) => {
    const typeConfig = invoiceTypes.find(t => t.value === type);
    return typeConfig ? typeConfig.color : 'gray';
  };

  const formatCurrency = (amount, currency = 'EUR') => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  // Filtrage et recherche
  const filteredInvoices = invoices.filter(invoice => {
    const matchesSearch = invoice.number.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         invoice.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         invoice.property.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || invoice.status === filterStatus;
    const matchesType = filterType === 'all' || invoice.type === filterType;
    
    return matchesSearch && matchesStatus && matchesType;
  });

  // Fonction pour créer une nouvelle facture
  const handleCreateInvoice = () => {
    const invoiceNumber = `FAC-2024-${String(invoices.length + 1).padStart(3, '0')}`;
    const newInvoiceData = {
      id: `INV-2024-${String(invoices.length + 1).padStart(3, '0')}`,
      number: invoiceNumber,
      ...newInvoice,
      status: 'draft',
      issueDate: new Date().toISOString().split('T')[0],
      amount: newInvoice.items.reduce((sum, item) => sum + (item.quantity * item.unitPrice), 0),
      vatAmount: newInvoice.items.reduce((sum, item) => sum + (item.quantity * item.unitPrice * item.vatRate / 100), 0)
    };

    setInvoices([...invoices, newInvoiceData]);
    setShowNewInvoiceModal(false);
    setNewInvoice({
      type: 'villa-rental',
      client: '',
      clientId: '',
      property: '',
      propertyId: '',
      booking: '',
      bookingId: '',
      items: [{ description: '', quantity: 1, unitPrice: 0, vatRate: 20 }],
      discountRate: 0,
      notes: '',
      dueDate: '',
      currency: 'EUR'
    });
  };

  return (
    <div className="invoices-management min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 p-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Gestion des Factures</h1>
            <p className="text-gray-600 mt-2">Création, suivi et gestion complète de votre facturation</p>
          </div>
          <div className="flex items-center space-x-3 mt-4 lg:mt-0">
            <button 
              onClick={() => setShowFiltersModal(true)}
              className="flex items-center space-x-2 px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
            >
              <Filter size={18} />
              <span>Filtres</span>
            </button>
            <button 
              onClick={() => alert('Export Excel en cours...')}
              className="flex items-center space-x-2 px-4 py-2 text-blue-600 border border-blue-300 rounded-lg hover:bg-blue-50"
            >
              <Download size={18} />
              <span>Export</span>
            </button>
            <button 
              onClick={() => setShowNewInvoiceModal(true)}
              className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              <Plus size={18} />
              <span>Nouvelle Facture</span>
            </button>
          </div>
        </div>

        {/* Statistiques */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <FileText className="text-blue-600" size={24} />
              <span className="text-xs text-blue-600">Total</span>
            </div>
            <div className="text-2xl font-bold text-blue-600">{stats.totalInvoices}</div>
            <div className="text-sm text-gray-600">Factures</div>
            <div className="text-lg font-semibold text-gray-800 mt-1">
              {formatCurrency(stats.totalAmount)}
            </div>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <CheckCircle className="text-green-600" size={24} />
              <span className="text-xs text-green-600">Payées</span>
            </div>
            <div className="text-2xl font-bold text-green-600">{stats.paidInvoices}</div>
            <div className="text-sm text-gray-600">Factures</div>
            <div className="text-lg font-semibold text-gray-800 mt-1">
              {formatCurrency(stats.paidAmount)}
            </div>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <Clock className="text-yellow-600" size={24} />
              <span className="text-xs text-yellow-600">En attente</span>
            </div>
            <div className="text-2xl font-bold text-yellow-600">{stats.pendingInvoices}</div>
            <div className="text-sm text-gray-600">Factures</div>
            <div className="text-lg font-semibold text-gray-800 mt-1">
              {formatCurrency(stats.pendingAmount)}
            </div>
          </div>

          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <AlertTriangle className="text-red-600" size={24} />
              <span className="text-xs text-red-600">En retard</span>
            </div>
            <div className="text-2xl font-bold text-red-600">{stats.overdueInvoices}</div>
            <div className="text-sm text-gray-600">Factures</div>
            <div className="text-lg font-semibold text-gray-800 mt-1">
              {formatCurrency(stats.overdueAmount)}
            </div>
          </div>
        </div>
      </div>

      <div className="p-6">
        {/* Barre de recherche et filtres rapides */}
        <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
            <div className="flex-1 max-w-md">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="text"
                  placeholder="Rechercher une facture, client, propriété..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="all">Tous les statuts</option>
                {invoiceStatuses.map(status => (
                  <option key={status.value} value={status.value}>{status.label}</option>
                ))}
              </select>

              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="all">Tous les types</option>
                {invoiceTypes.map(type => (
                  <option key={type.value} value={type.value}>{type.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Liste des factures */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Facture
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Client
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Type
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Propriété
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Montant
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Échéance
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Statut
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredInvoices.map((invoice) => {
                  const StatusIcon = getStatusIcon(invoice.status);
                  const typeConfig = invoiceTypes.find(t => t.value === invoice.type);
                  const TypeIcon = typeConfig ? typeConfig.icon : FileText;

                  return (
                    <tr key={invoice.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div>
                          <div className="text-sm font-medium text-gray-800">{invoice.number}</div>
                          <div className="text-sm text-gray-600">{formatDate(invoice.issueDate)}</div>
                          {invoice.booking && (
                            <div className="text-xs text-blue-600">{invoice.booking}</div>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div>
                          <div className="text-sm font-medium text-gray-800">{invoice.client}</div>
                          <div className="text-sm text-gray-600">{invoice.clientEmail}</div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center space-x-2">
                          <div className={`p-2 rounded-lg bg-${getTypeColor(invoice.type)}-100`}>
                            <TypeIcon className={`text-${getTypeColor(invoice.type)}-600`} size={16} />
                          </div>
                          <span className="text-sm font-medium text-gray-800">{invoice.typeName}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-800">{invoice.property}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-bold text-gray-800">
                          {formatCurrency(invoice.amount, invoice.currency)}
                        </div>
                        {invoice.vatAmount > 0 && (
                          <div className="text-xs text-gray-600">
                            TVA: {formatCurrency(invoice.vatAmount, invoice.currency)}
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-800">{formatDate(invoice.dueDate)}</div>
                        {invoice.paidDate && (
                          <div className="text-xs text-green-600">Payé: {formatDate(invoice.paidDate)}</div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-${getStatusColor(invoice.status)}-100 text-${getStatusColor(invoice.status)}-800`}>
                          <StatusIcon size={12} className="mr-1" />
                          {invoiceStatuses.find(s => s.value === invoice.status)?.label}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => setSelectedInvoice(invoice)}
                            className="text-blue-600 hover:text-blue-900"
                          >
                            <Eye size={16} />
                          </button>
                          <button
                            onClick={() => alert(`Édition de la facture ${invoice.number}`)}
                            className="text-green-600 hover:text-green-900"
                          >
                            <Edit size={16} />
                          </button>
                          <button
                            onClick={() => alert(`Envoi de la facture ${invoice.number}`)}
                            className="text-purple-600 hover:text-purple-900"
                          >
                            <Send size={16} />
                          </button>
                          <button
                            onClick={() => alert(`Suppression de la facture ${invoice.number}`)}
                            className="text-red-600 hover:text-red-900"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Nouvelle Facture */}
      {showNewInvoiceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-gray-800">Nouvelle Facture</h3>
              <button
                onClick={() => setShowNewInvoiceModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X size={24} />
              </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Partie gauche */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Type de facture</label>
                  <select
                    value={newInvoice.type}
                    onChange={(e) => setNewInvoice({...newInvoice, type: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {invoiceTypes.map(type => (
                      <option key={type.value} value={type.value}>{type.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Client</label>
                  <select
                    value={newInvoice.clientId}
                    onChange={(e) => {
                      const client = clients.find(c => c.id === e.target.value);
                      setNewInvoice({
                        ...newInvoice, 
                        clientId: e.target.value,
                        client: client ? client.name : ''
                      });
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">Sélectionner un client</option>
                    {clients.map(client => (
                      <option key={client.id} value={client.id}>{client.name}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Propriété</label>
                  <select
                    value={newInvoice.propertyId}
                    onChange={(e) => {
                      const property = properties.find(p => p.id === e.target.value);
                      setNewInvoice({
                        ...newInvoice, 
                        propertyId: e.target.value,
                        property: property ? property.name : ''
                      });
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">Sélectionner une propriété</option>
                    {properties.map(property => (
                      <option key={property.id} value={property.id}>{property.name}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Réservation liée (optionnel)</label>
                  <input
                    type="text"
                    value={newInvoice.booking}
                    onChange={(e) => setNewInvoice({...newInvoice, booking: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="RES-2024-XXX"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Date d'échéance</label>
                  <input
                    type="date"
                    value={newInvoice.dueDate}
                    onChange={(e) => setNewInvoice({...newInvoice, dueDate: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>

              {/* Partie droite */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Lignes de facturation</label>
                  <div className="space-y-3">
                    {newInvoice.items.map((item, index) => (
                      <div key={index} className="p-4 border border-gray-200 rounded-lg">
                        <div className="grid grid-cols-1 gap-3">
                          <input
                            type="text"
                            placeholder="Description du service/produit"
                            value={item.description}
                            onChange={(e) => {
                              const updatedItems = [...newInvoice.items];
                              updatedItems[index].description = e.target.value;
                              setNewInvoice({...newInvoice, items: updatedItems});
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                          />
                          <div className="grid grid-cols-3 gap-2">
                            <input
                              type="number"
                              placeholder="Qté"
                              value={item.quantity}
                              onChange={(e) => {
                                const updatedItems = [...newInvoice.items];
                                updatedItems[index].quantity = parseInt(e.target.value) || 0;
                                setNewInvoice({...newInvoice, items: updatedItems});
                              }}
                              className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                            />
                            <input
                              type="number"
                              placeholder="Prix unitaire"
                              value={item.unitPrice}
                              onChange={(e) => {
                                const updatedItems = [...newInvoice.items];
                                updatedItems[index].unitPrice = parseFloat(e.target.value) || 0;
                                setNewInvoice({...newInvoice, items: updatedItems});
                              }}
                              className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                            />
                            <select
                              value={item.vatRate}
                              onChange={(e) => {
                                const updatedItems = [...newInvoice.items];
                                updatedItems[index].vatRate = parseInt(e.target.value);
                                setNewInvoice({...newInvoice, items: updatedItems});
                              }}
                              className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                            >
                              <option value={0}>0% TVA</option>
                              <option value={10}>10% TVA</option>
                              <option value={20}>20% TVA</option>
                            </select>
                          </div>
                        </div>
                        {newInvoice.items.length > 1 && (
                          <button
                            onClick={() => {
                              const updatedItems = newInvoice.items.filter((_, i) => i !== index);
                              setNewInvoice({...newInvoice, items: updatedItems});
                            }}
                            className="mt-2 text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={14} />
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      onClick={() => {
                        setNewInvoice({
                          ...newInvoice,
                          items: [...newInvoice.items, { description: '', quantity: 1, unitPrice: 0, vatRate: 20 }]
                        });
                      }}
                      className="w-full px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-blue-500 hover:text-blue-600"
                    >
                      <Plus size={16} className="inline mr-2" />
                      Ajouter une ligne
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Notes (optionnel)</label>
                  <textarea
                    value={newInvoice.notes}
                    onChange={(e) => setNewInvoice({...newInvoice, notes: e.target.value})}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Notes additionnelles..."
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={() => setShowNewInvoiceModal(false)}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Annuler
              </button>
              <button
                onClick={handleCreateInvoice}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Créer la Facture
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Filtres */}
      {showFiltersModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-gray-800">Filtres avancés</h3>
              <button
                onClick={() => setShowFiltersModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X size={24} />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Période</label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                  <option>Toutes les périodes</option>
                  <option>Ce mois</option>
                  <option>Mois dernier</option>
                  <option>Ce trimestre</option>
                  <option>Cette année</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Montant</label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                  <option>Tous les montants</option>
                  <option>Moins de €1,000</option>
                  <option>€1,000 - €10,000</option>
                  <option>€10,000 - €50,000</option>
                  <option>Plus de €50,000</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Client</label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                  <option>Tous les clients</option>
                  {clients.map(client => (
                    <option key={client.id} value={client.id}>{client.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={() => setShowFiltersModal(false)}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Réinitialiser
              </button>
              <button
                onClick={() => setShowFiltersModal(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Appliquer Filtres
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Détail Facture */}
      {selectedInvoice && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-gray-800">Facture {selectedInvoice.number}</h3>
              <button
                onClick={() => setSelectedInvoice(null)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X size={24} />
              </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Informations générales */}
              <div className="space-y-4">
                <div className="p-4 border border-gray-200 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-3">Informations générales</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Numéro:</span>
                      <span className="font-medium">{selectedInvoice.number}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Type:</span>
                      <span className="font-medium">{selectedInvoice.typeName}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Date d'émission:</span>
                      <span className="font-medium">{formatDate(selectedInvoice.issueDate)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Date d'échéance:</span>
                      <span className="font-medium">{formatDate(selectedInvoice.dueDate)}</span>
                    </div>
                    {selectedInvoice.paidDate && (
                      <div className="flex justify-between">
                        <span className="text-gray-600">Date de paiement:</span>
                        <span className="font-medium text-green-600">{formatDate(selectedInvoice.paidDate)}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="p-4 border border-gray-200 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-3">Client</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Nom:</span>
                      <span className="font-medium">{selectedInvoice.client}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Email:</span>
                      <span className="font-medium">{selectedInvoice.clientEmail}</span>
                    </div>
                  </div>
                </div>

                {selectedInvoice.booking && (
                  <div className="p-4 border border-gray-200 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-3">Réservation liée</h4>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Réservation:</span>
                        <span className="font-medium text-blue-600">{selectedInvoice.booking}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Propriété:</span>
                        <span className="font-medium">{selectedInvoice.property}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Détails financiers */}
              <div className="space-y-4">
                <div className="p-4 border border-gray-200 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-3">Lignes de facturation</h4>
                  <div className="space-y-2">
                    {selectedInvoice.items.map((item, index) => (
                      <div key={index} className="pb-2 border-b border-gray-100 last:border-b-0">
                        <div className="text-sm font-medium text-gray-800">{item.description}</div>
                        <div className="text-xs text-gray-600">
                          {item.quantity} × {formatCurrency(item.unitPrice)} 
                          {item.vatRate > 0 && ` (TVA ${item.vatRate}%)`}
                        </div>
                        <div className="text-sm font-semibold text-right">
                          {formatCurrency(item.quantity * item.unitPrice)}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="p-4 border border-gray-200 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-3">Totaux</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Sous-total HT:</span>
                      <span className="font-medium">
                        {formatCurrency(selectedInvoice.amount - selectedInvoice.vatAmount)}
                      </span>
                    </div>
                    {selectedInvoice.discountAmount > 0 && (
                      <div className="flex justify-between">
                        <span className="text-gray-600">Remise:</span>
                        <span className="font-medium text-red-600">
                          -{formatCurrency(selectedInvoice.discountAmount)}
                        </span>
                      </div>
                    )}
                    {selectedInvoice.vatAmount > 0 && (
                      <div className="flex justify-between">
                        <span className="text-gray-600">TVA:</span>
                        <span className="font-medium">{formatCurrency(selectedInvoice.vatAmount)}</span>
                      </div>
                    )}
                    <div className="flex justify-between border-t pt-2">
                      <span className="font-semibold text-gray-800">Total TTC:</span>
                      <span className="font-bold text-lg">
                        {formatCurrency(selectedInvoice.amount, selectedInvoice.currency)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={() => alert('Impression PDF')}
                className="px-4 py-2 text-blue-600 border border-blue-300 rounded-lg hover:bg-blue-50"
              >
                <Download size={16} className="inline mr-2" />
                PDF
              </button>
              <button
                onClick={() => alert('Envoi par email')}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                <Send size={16} className="inline mr-2" />
                Envoyer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoicesManagement;